import { throttle } from "../../../_src/js/Util";

App.document.ready(() => {
    if (App.H.hasClass("page-main") && $(".js-header").length > 0) {
        const firstScreenBottom = document
            .querySelector(".js-first-screen")
            .getBoundingClientRect().height;
        setHeaderPosition(firstScreenBottom);

        App.W.on(
            "scroll",
            throttle(() => setHeaderPosition(firstScreenBottom), 100)
        );
    }

    $(".js-header-catalog-btn").on("click", function () {
        $(".js-header-catalog").slideToggle(200);
        $(this).toggleClass("_active");
        App.H.toggleClass("_menu-opened");

        if (App.W.width() < 1140) {
            if ($(this).hasClass("_active")) {
                App.lockScroll.lock();
            } else {
                App.lockScroll.unlock();
            }

            const $navButtons = $('.js-header-right').html();
            $('.js-navigation-buttons').html($navButtons);
        }
    });

    $(".js-header-catalog-close").on("click", function () {
        $(".js-header-catalog").slideUp(200);
        $(this).removeClass("_active");
        App.H.removeClass("_menu-opened");
        $('.js-navigation-buttons').html('');
        App.lockScroll.unlock();
    });

    $(".js-header-dropdown-btn").on("click", function () {
        $(".js-header-dropdown-btn").not(this).removeClass("_active");

        if (App.W.width() >= 1140) {
            $(".js-header-dropdown-btn:not(._active)").siblings(".js-header-dropdown").slideUp(200);
            $(this).siblings(".js-header-dropdown").slideToggle(200);
        }

        $(this).toggleClass("_active");
    });


    App.H.on("click", function (e) {
        if (
            App.H.hasClass("_menu-opened") &&
            !$(this).hasClass(".js-header-catalog") &&
            !$(e.target).parents().addBack().is(".js-header-catalog") &&
            !$(this).hasClass(".js-header-catalog-btn") &&
            !$(e.target).parents().addBack().is(".js-header-catalog-btn")
        ) {
            $(".js-header-catalog-btn").removeClass("_active");
            $(".js-header-catalog").slideUp(200);
            App.H.removeClass("_menu-opened");
            App.lockScroll.unlock();
        }

        if (
            !$(this).hasClass(".js-header-dropdown") &&
            !$(e.target).parents().addBack().is(".js-header-dropdown") &&
            !$(this).hasClass(".js-header-dropdown-btn") &&
            !$(e.target).parents().addBack().is(".js-header-dropdown-btn")
        ) {
            if (App.W.width() >= 1140) {
                $(".js-header-dropdown").slideUp(200);
            }
            $(".js-header-dropdown-btn").removeClass("_active");
        }

        if (
            !$(this).hasClass(".js-city") &&
            !$(e.target).parents().addBack().is(".js-city")
        ) {
            $(".js-message-city").removeClass("_active");
            $(".js-city-list-wrap").removeClass("_active");
        }
    });

    // setNavigationDropdown();
    // setServicesPosition();

    App.W.on("resize", () => {
        // setNavigationDropdown();
        // setServicesPosition();

        if (App.W.width() < 768) {
            $(".js-header-catalog").slideUp(200);
            $(".js-header-catalog-btn").removeClass("_active");
            App.H.removeClass("_menu-opened");
            $(".js-header-dropdown").slideUp(200);
            $(".js-header-dropdown-btn").removeClass("_active");
            App.B.removeClass("_noscroll");
        }
        if (App.W.width() >= 1140) {
            $(".js-header-catalog").removeAttr('style');
        }
    });
});

function setNavigationDropdown() {
    const $navigation = $(".js-navigation");
    const $navigationLinks = $navigation.find(".navigation__item");
    const $navigationDropdown = $navigation.siblings(".js-header-dropdown");
    const $navigationDropdownLinks = $navigationDropdown.find(
        ".header-dropdown__item"
    );

    if (App.W.width() < 767) {
        $navigationLinks.each((ind, link) => {
            const $tempLink = $(link)
                .removeClass("navigation__item")
                .addClass("header-dropdown__item");
            $navigationDropdown.append($tempLink);
        });
    } else if (App.W.width() < 1139) {
        if ($navigationLinks.length < 3) {
            $navigationDropdownLinks.each((ind, link) => {
                const $tempLink = $(link)
                    .removeClass("header-dropdown__item")
                    .addClass("navigation__item");
                $navigation.append($tempLink);
            });
        }

        $navigationLinks.each((ind, link) => {
            if (ind > 2) {
                const $tempLink = $(link)
                    .removeClass("navigation__item")
                    .addClass("header-dropdown__item");
                $navigationDropdown.append($tempLink);
            }
        });
    } else {
        $navigationDropdownLinks.each((ind, link) => {
            const $tempLink = $(link)
                .removeClass("header-dropdown__item")
                .addClass("navigation__item");
            $navigation.append($tempLink);
        });
    }
}

function setHeaderPosition(firstScreenBottom) {
    const scrollTop = $(window).scrollTop();

    if (scrollTop >= firstScreenBottom) {
        $(".js-header").addClass("_header-sticky");
    } else {
        $(".js-header").removeClass("_header-sticky");
    }
}

function setServicesPosition() {
    if (!$(".js-header-services").length) {
        return;
    }

    const $headerServices =
        $(".js-header-services").html().length > 0
            ? $(".js-header-services").html()
            : $(".js-header-services-mobile").html();

    if (App.W.width() < 767) {
        $(".js-header-services-mobile").html($headerServices);
        $(".js-header-services").html("");
    } else {
        $(".js-header-services").html($headerServices);
        $(".js-header-services-mobile").html("");
    }
}

let $currentCity = $(".js-current-city");

$currentCity.click(function () {
    $(this).siblings(".js-message-city").toggleClass("_active");
});

$(".js-accept-city").click(function (e) {
    e.preventDefault();
    $(this).closest(".js-message-city").removeClass("_active");
});

$(".js-change-city").click(function (e) {
    e.preventDefault();
    let $el = $(this);
    $el.closest(".js-message-city").removeClass("_active");
    $el.closest(".js-message-city")
        .siblings(".js-city-list-wrap")
        .addClass("_active");
});
